import EntitySearchInput from "components/form/EntitySearch/EntitySearchInput";
import { useFieldValue } from "components/form/input/NestedField";
import TextInput from "components/form/input/TextInput";
import ApontamentoColetas from "entity/Indicador/components/apontamento/fields/ApontamentoColetas";
import ApontamentoCommonFields from "entity/Indicador/components/apontamento/fields/ApontamentoCommonFields";
import ApontamentoImages from "entity/Indicador/components/apontamento/fields/ApontamentoImages";
import ApontamentoClienteParams, {
    ApontamentoParamItem,
} from "entity/Indicador/components/apontamento/fields/ApontamentoClienteParams";
import ApontamentoAmostraParams, {
    useTipoApontamento,
} from "entity/Indicador/components/apontamento/fields/ApontamentoAmostraParams";
import ApontamentoResultado from "entity/Indicador/components/apontamento/fields/ApontamentoResultado";
import ApontamentoObservacao from "entity/Indicador/components/apontamento/fields/ApontamentoObservacao";
import { useEffect, useMemo } from "react";
import FormRow from "components/form/FormRow";
import SelectInput from "components/form/input/SelectInput";
import { useForm } from "react-final-form"
import ABA from "..";
import Operador from "entity/Operador";

export default function ABAEditFields({ visita, TipoClass }) {
    const [tipo, setTipo] = useTipoApontamento()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const params = useMemo(() => visita.cliente.getParams(ABA, "Mecanizado", TipoClass), [visita.cliente])

    const [apontamento] = useFieldValue();
    const form = useForm()

    useEffect(() => {
        if (tipo !== "Mecanizado") {
            setTipo("Mecanizado")
        }
    }, [setTipo, tipo])

    useEffect(() => {
        if (apontamento) {
            apontamento.conformidade = ABA.calcConformidade(apontamento, params);
            form.change("conformidade", ABA.calcConformidade(apontamento, params))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apontamento, params]);

    return (
        <>
            <ApontamentoCommonFields visita={visita} showImplemento={false} />

            <ApontamentoAmostraParams tipoFixedValue="Mecanizado">
                <FormRow>
                    <SelectInput name="turno" label="Turno" options={["A", "B", "C"]} required />
                </FormRow>
                <FormRow>
                    <EntitySearchInput name="operador" label="Operador" EntityClass={Operador} extraQuery={(query) => query.where("cliente.uid", "==", visita.data.cliente.uid)} />
                </FormRow>
            </ApontamentoAmostraParams>

            <ApontamentoClienteParams params={params}>
                {params ? (
                    <>
                        <ApontamentoParamItem label="Meta (%):">{params.meta}</ApontamentoParamItem>
                    </>
                ) : null}
            </ApontamentoClienteParams>

            <ApontamentoColetas visita={visita}>
                <TextInput type="number" name="avaliados" label="Qtd. Canas Avaliadas" />
                <TextInput type="number" name="abalados" label="Tocos Abalados" />
                <TextInput name="abalo" label="Abalos (%)" disabled />
            </ApontamentoColetas>

            <ApontamentoResultado conformidadeLabel="Média por Levantamento (%)" />
            <ApontamentoObservacao />
            <ApontamentoImages visita={visita} />
        </>
    );
}
